const screens = {
	xxsmall: "320px",
	xsmall: "480px",
	small: "600px",
	medium: "768px",
	large: "1024px",
	xlarge: "1441px",
	largeMenu: "1080px",
};

const grids = {
	maxWidth: "1440px",
	largeWidth: "1280px",
	minWidth: "944px",
	maxContentWidth: "720px",
	maxContentWidthTablet: "500px",
	maxContentWidthMobile: "320px",
	maxFeaturedVideoWidth: "111.3rem",
};

const Sizes = {
	screens,
	grids,
};

export default Sizes;
